export default "__VITE_ASSET__BtGFHife__"